import { render, staticRenderFns } from "./HasilKompetensi.vue?vue&type=template&id=c70c8aae&scoped=true&lang=html&"
import script from "./HasilKompetensi.vue?vue&type=script&lang=js&"
export * from "./HasilKompetensi.vue?vue&type=script&lang=js&"
import style0 from "./HasilKompetensi.vue?vue&type=style&index=0&id=c70c8aae&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70c8aae",
  null
  
)

export default component.exports